import { h, Component } from 'preact';
import Store from 'store/store';
import * as actions from 'store/actions';
import { joinClasses } from 'utils/utils';
import s from 'components/shared/theaters/datesScrollerDate.sss';
import pure from 'utils/pure';


export default @pure class DatesScrollerDate extends Component {

	constructor(props) {
		super(props);
		this.select = this.select.bind(this);
	}

	select() {
		Store.emit(actions.SELECT_ST_DATE, this.props.stDate);
	}

	render({ selected, stDate }) {
		const classes = joinClasses('date', s.date, selected && 'selected', selected && s.selected);

		return (
			<div class={classes} onClick={this.select}>
				<div class={s.name}>{stDate.dayShort}</div>
				<div class={s.month}>{stDate.monthShort}</div>
				<div class={s.num}>{stDate.dateNum}</div>
			</div>
		);
	}

}
